import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import ZaloPersonalApi from "../../../api/zalo-personal.api";
import './ModalLoginQrCodeZalo.sass';
import Actions from "../../../constants/Actions";
import store from "../../../store";
import { Image, Modal, message } from 'antd';

const ModalLoginQrCodeZalo = React.memo((props) => {
    const { showModal, setShowModal } = props;
    const zaloQrcode = useSelector(state => state.io.zalo_qrcode);
    const [qrCode, setQrCode] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!zaloQrcode) {
            return;
        }

        if (zaloQrcode.type === 'qrcode') {
            setQrCode(zaloQrcode.data.data);
            store.dispatch({ type: Actions.ZALO_QRCODE, zalo_qrcode: {} });
        }

        if (zaloQrcode.type === 'login-success') {
            setShowModal(false)
            message.success(`Đăng nhập vào Zalo cá nhân thành công!`)
            store.dispatch({ type: Actions.ZALO_QRCODE, zalo_qrcode: {} });
        }

    }, [zaloQrcode]);

    useEffect(() => {
        loginQrCode()
    }, []);

    const loginQrCode = async() => {
        setLoading(true);

        try {
            let res = await ZaloPersonalApi.login({});
            const response = res.data;

            if (!response.error) {
                setLoading(false)
            }
        } catch (error) {
            console.log('Có lỗi xảy ra!');
        } finally {
            setLoading(false);
        }
    };

    const ZaloQrCode = () => {
        if (zaloQrcode?.type === 'scan-qrcode') {
            return (<div className = "qrcode-scan text-center" >
                <Image src = { zaloQrcode.data?.avatar } style={{ width: '100px', height: '100px', borderRadius: '50%' } } alt="Avatar User"/>
                <p style = {{ marginTop: '10px', fontWeight: 800 }}> {zaloQrcode.data?.display_name}</p> 
                <p> Quét mã thành công. <br/> Vui lòng chọn "Đăng nhập" trên thiết bị di động của bạn </p> </div>
            )
        } else {
            return (<div className = "qrcode text-center" style={{ minHeight: '200px'}}> 
                    {(!loading && qrCode) && < Image src = { `data:image/png;base64,${qrCode.image}`} style={{ width: '200px', height: '200px', minHeight: '200px' } } alt = "Qr Code Zalo" />} 
                    <p> Quét mã QR code để đăng nhập vào Zalo </p> 
                </div>
            )
        }
    }

    return (<Modal open = { showModal }
        id="modal-login-zalo"
        title="Đăng nhập Zalo Cá Nhân"
        onCancel={
            () => setShowModal(false) }
        width={ 600 }
        footer={ null }
        confirmLoading={ loading }
        centered>
            <div className = "qr-code-login-wrapper" >
                <ZaloQrCode/>
            </div> 
        </Modal>
    );
});

export default ModalLoginQrCodeZalo;